<ng-container *ngIf="!viewNotificationFirma">
    <div id="compensacion-deudas-excedentes">
        <app-card class="box-wrapper-home" Theme="card-primary shadow background-white">
            <div card-content *ngIf="activeBreadCrumbs">
                <app-bread-crumb>
                    <li rutas-bread>Compensación de deudas </li>
                    <span rutas-bread class="separador-bread">
                    <img src="./assets/img/ico_arrow_breadcrumd.svg" />
                    </span>
                    <li rutas-bread class="activo-bread">Excedentes por Restitución</li>
                </app-bread-crumb>
            </div>
            
            <div class="box-wrapper-restitucion" card-content>
                <div *ngIf="viewTabMenuRestitucion">
                    <app-tab-menu-restitucion (tabViewSelected)="getTabViewSelected($event)" [Theme]="themeTabMenu" [Items]=dataTabMenu>
                    </app-tab-menu-restitucion>
                </div>
                <div >
                    <app-tab-view Theme="tab-view-primitive">
                         <!-- BIFURCACION AFILIADOS/EXAFILIADOS-NOAFILIADOS -->
                  <div class="tabView" tab-view-content>
                    <ng-container *ngIf="tabView_index == 10">
                      <div>
                        <app-body Theme="body-normal">
                            <div body-content>
                                <div class="head-form">
                                    <!-- 
                                    <app-icon class="icon"
                                        [Path]="'assets/img/iconos/ico_ingresar-sucursal-virtual.svg'"></app-icon>
                                        -->
                                    <app-text Theme="Heading3" Text="Beneficio de condonación de intereses y recargos"
                                        [RadiusLoading]="10" style="color:#0078C8;" *ngIf="activeHead"></app-text>
                                    <br/>
                                    
                                      <app-text Theme="BodyRegular" Text="{{textBienvenido}}"
                                        [RadiusLoading]="10" style="color:#757575; text-align: justify !important;"></app-text>
                                    
                                        <ng-container *ngIf="typeApp === '0'">
                                            <p class="link">Si quieres conocer más detalles sobre el fallo, <span (click)="goToLink()">haz click aqui</span></p>
                                        </ng-container>
                                       
                                </div>
                                <div class="box-bifurcacion-usuario">
                                     <div class="box-bifurcacion">
                                        <app-card Theme="card-primary shadow background-white">
                                            <div card-content>
                                                <app-body Theme="body-normal">
                                                    <div body-content>
                                                      <div class="imagen">
                                                        <img src="./assets/img/logo-colmena.svg">
                                                      </div>

                                                      <div class="body">
                                                        <app-text Theme="BodyRegular" Text="Accede a tu sucursal virtual para suscribir el beneficio." [RadiusLoading]="10" style="color:#757575;text-align: justify;"></app-text>
                                                      </div>

                                                      <div class="callToAction">
                                                        <p-button 
                                                          label="Sucursal virtual" 
                                                          [loading]="loading" 
                                                          (onClick)="ingresarUsuarioBifurcacion('afiliado')"
                                                          styleClass="btn-colmena"
                                                          />
                                                      </div>

                                                    </div>
                                                </app-body>
                                            </div>
                                        </app-card>
                                     </div>
                                     <div class="no-afilado">
                                      <app-card Theme="card-primary shadow background-white">
                                        <div card-content>
                                            <app-body Theme="body-normal">
                                                <div body-content>
                                                  <div class="imagen inline-text">
                                                    <!-- <img src="./assets/img/ico_error.svg"> -->
                                                    <app-text Theme="Heading3" Text="Ex Afiliados"
                                                      [RadiusLoading]="10" style="color:#0078C8;" *ngIf="activeHead"></app-text>
                                                  </div>

                                                  <div class="body">
                                                    <app-text Theme="BodyRegular" Text="Si eres ex afiliado Colmena, consulta aquí si puedes optar al beneficio." [RadiusLoading]="10" style="color:#757575;text-align: justify;"></app-text>
                                                  </div>

                                                  <div class="callToAction">
                                                    <p-button 
                                                      label="Consultar" 
                                                      [loading]="loading" 
                                                      (onClick)="ingresarUsuarioBifurcacion('no-afiliado')"
                                                      styleClass="btn-colmena"
                                                      />
                                                  </div>

                                                </div>
                                            </app-body>
                                        </div>
                                    </app-card>
                                     </div>
                                    

                                </div>
                            </div>
                        </app-body>
                      </div>
                    </ng-container>
                  </div>
                        <!-- LOGIN VALIDACION EQUIFAX -->
                        <div class="tabView" tab-view-content>
                        <ng-container *ngIf="tabView_index == 0">
                            <div>
                            <app-body Theme="body-normal">
                                <div body-content>
                                    <div class="head-form">
                                        <!-- 
                                        <app-icon class="icon"
                                            [Path]="'assets/img/iconos/ico_ingresar-sucursal-virtual.svg'"></app-icon>
                                            -->
                                        <app-text Theme="Heading3" Text="Beneficio de condonación de intereses y recargos"
                                            [RadiusLoading]="10" style="color:#0078C8;"></app-text>
                                        <br/>
                                            <app-text Theme="BodyRegular" Text="{{textBienvenido}}"
                                            [RadiusLoading]="10" style="color:#757575; text-align: justify;"></app-text>
                                        
                                            <ng-container *ngIf="typeApp === '0'">
                                                <p class="link">Si quieres conocer más detalles sobre el fallo, <span (click)="goToLink()">haz click aqui</span></p>
                                            </ng-container>
                                            
                                    </div>
                                    <div class="box-restitucion">
                                        <div class="box-form">
                                            <app-card Theme="card-primary shadow background-white">
                                                <div card-content>
                                                    <app-body Theme="body-normal">
                                                        <div body-content>
                                                            <form [formGroup]="formData">
                                                                <div class="box-campo-input">
                                                                    <app-text Theme="CaptionRegular" Text="RUT:" [RadiusLoading]="10" style="color:#0078C8;"></app-text>                                                            
                                                                    <input [pKeyFilter]="filterRut" class="inputt" type="text" formControlName="username" placeholder="00000000-0" (input)="onRutInput($event)" [ngClass]="{'is-invalid': submitted && f['username'].errors}" maxlength="10" pKeyFilter="alphanum" (blur)="verifyRut()" />
                                                                    <div class="error">
                                                                        <div *ngIf="submitted && f['username'].errors">
                                                                            <p *ngIf="f['username'].errors['required']">
                                                                                Campo obligatorio
                                                                            </p>
                                                                        </div>
                                                                        <div *ngIf="verifyRutCampo">
                                                                            <p>
                                                                                El rut no es válido
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="box-campo-input">
                                                                    <app-text Theme="CaptionRegular" Text="N° Dcto Cédula de Identidad" [RadiusLoading]="10" style="color:#0078C8;"></app-text>                                                            
                                                                    <input class="inputt" type="text" formControlName="nDocumento" placeholder="00000000" [ngClass]="{'is-invalid': submitted && f['nDocumento'].errors}" maxlength="9" pKeyFilter="alphanum" (blur)="verifyNDocumento()" />
                                                                    <div class="error">
                                                                        <div *ngIf="submitted && f['nDocumento'].errors">
                                                                            <p *ngIf="f['nDocumento'].errors['required']">
                                                                                Campo obligatorio
                                                                            </p>
                                                                        </div>
                                                                        <div *ngIf="verifyDctoCampo">
                                                                            <p>
                                                                                El número de documento no es válido
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="callToAction" *ngIf="!nuevaConsulta">
                                                                    <p-button 
                                                                    label="Consultar" 
                                                                    [loading]="loading" 
                                                                    (onClick)="onSubmit()"
                                                                    styleClass="btn-colmena"
                                                                    />
                                                                    <!-- <button [ngClass]="{'disabledBtn': disabledBtn}" tabindex="3" class="btn-submit" type="submit" (click)="onSubmit()">Consultar</button> -->
                                                                </div>
                                                                <div body-content class="callToAction" *ngIf="nuevaConsulta">
                                                                    <button tabindex="3" class="btn-submit" type="submit" (click)="refreshPage()">Realizar otra consulta</button>
                                                                </div>
                                                            </form>                                                  
                                                        </div>
                                                    </app-body>
                                                </div>
                                            </app-card>
                                        </div>
                                        <div class="imagen-restitucion">
                                            <img src="./assets/img/restitucion-por-excedentes.svg" />
                                        </div>
                                        
    
                                    </div>
                                </div>
                            </app-body>
                            </div>
                            <div>
                                <div class="box-recaptcha">
                                    <div id="recaptcha2"></div>
                                </div>
                            </div>
                        </ng-container>
                            
                        </div>
                    </app-tab-view>
                </div>
            </div>
            
            
            

            
        </app-card>
    </div>
    <app-modal-compensacion 
    [TituloModal]="tituloModal" 
    [Icono]="true" 
    [IcoSrc]="modalCustomIcon" 
    [Foo]="false" 
    (closeModal)="cerrarModal($event)" 
    [ViewModal]="viewModal" 
    [Theme]="themeBannerCompensacion"
    *ngIf="viewModal"
    >
        <p *ngIf="!viewModalNotifcation" mensaje-modal [innerHTML]="parrafoModal"></p>
        
        <ng-container mensaje-modal *ngIf="viewModalNotifcation">
            <div class="box-mandato-modal">
                <p>
                    1. Declaro estar en conocimiento de tener la condición de acreedor de la Isapre de restituciones generadas en virtud de la implementación de la Ley N° 21.674 ("Ley Corta de Isapres"), las que se otorgarán en calidad de excedentes, en las cuotas informadas por la Isapre, en una cuenta corriente especial de excedentes abierta para estos efectos, en la que se irá devengando mes a mes la cuota correspondiente a cada período. Declaro asimismo estar en conocimiento que estas cuotas comenzaron a devengarse en el mes de diciembre de 2024.<br/><br/>
          
                    2. Declaro que Isapre Colmena me ha informado acerca de la opción de compensar deudas que mantengo en esta Institución por concepto de cotizaciones y/o crédito Ley de Urgencia, con cargo al saldo disponible en mi cuenta de excedentes de restituciones, acelerando a su vez cuotas de restitución a valor nominal (sin aplicar tasa de descuento alguna), caso en el cual accederé a la condonación de los intereses y recargos asociados a los gastos de cobranza que la normativa legal dispone respecto de los montos que autorizo pagar.<br/><br/>
                    
                    3. En virtud de lo anterior, en forma libre y voluntaria, con la firma del presente documento, faculto expresamente a COLMENA GOLDEN CROSS S.A. <b>para que compense la(s) deuda(s) que mantengo en la Isapre por concepto de cotizaciones y/o crédito Ley de Urgencia, total o parcialmente, según corresponda, y cualquier otra deuda que por estos mismos conceptos pueda generarse en el futuro, con los excedentes generados en virtud del proceso de restitución de la Ley N° 21.674.<br/><br/>
                    
                    Para estos efectos, si a la fecha en que se ejecute la compensación, el saldo disponible en la cuenta de excedentes de restitución fuese menor a la(s) deuda(s) que mantengo por cualquiera de los conceptos señalados en el párrafo anterior, la Isapre acelerará las cuotas de restitución - sin aplicar tasa de descuento alguna - por un monto equivalente a la(s) deuda(s) que mantengo, hasta la total extinción de las mismas o hasta su extinción parcial en el caso que, acelerando la totalidad de las cuotas de restitución, los saldos disponibles no fuesen suficientes, caso en el cual operará respecto de los montos pagados bajo esta modalidad la condonación de los intereses y gastos de cobranza asociados a la(s) deuda(s).</b><br/><br/>
                    
                    Declaro asimismo estar en conocimiento que producto de la compensación que se realizará con las restituciones de la Isapre y de la aceleración de las cuotas de restituciones que ocurrirá por este mismo motivo, los pagos de las cuotas de restitución en mi cuenta de excedentes solo se reiniciarán por el saldo no compensado, en el número de cuota que corresponda, en la medida que no se hayan utilizado dichas restituciones en su totalidad para el pago de la(s) deuda(s) antes referidas.<br/><br/>
                    
                    Asimismo, declaro que en el evento que las cuotas de restituciones no sean suficiente para cubrir la totalidad de mi(s) deuda(s), continuará mi obligación de concurrir al pago de las mismas en mi condición de obligado al pago de éstas.
                    
                    Declaro también que, al optar por este mecanismo de pago para que se compensen deudas de cotizaciones y de crédito Ley de Urgencia, el orden de prelación que la Isapre aplicará será, en primer lugar, el pago de la deuda de cotizaciones. Si posterior a esta compensación aun existen saldos de restituciones, se compensará total o parcialmente la deuda por crédito Ley de Urgencia, hasta su extinción total o parcial, según los fondos disponibles.<br/><br/>
                    
                    4. En el evento que el mecanismo de pago que por este acto autorizo involucre deudas de cotizaciones, declaro que mantengo en la Isapre la condición de cotizante independiente o voluntario, o bien, que tuve en algún momento dicha condición y que, por ello, me encuentro o me encontré durante un período de tiempo, obligado al pago de mis cotizaciones de salud conforme lo establecen las Condiciones Generales del Contrato de Salud suscrito con Colmena Golden Cross S.A. y la normativa vigente.<br/><br/>
                    
                    5. El presente Mandato y Autorización de Compensación y Pago Deuda(s) con cargo a excedentes de restituciones se entenderá vigente, para todos los efectos legales, a contar del mismo día de suscripción del mismo. Asimismo, se entenderá renovado en iguales términos, en tanto no se revoque por escrito. Esta revocación se hará efectiva a contar del mes siguiente de su recepción por parte de la Isapre y deberá ser efectuada a esta última en forma escrita.<br/><br/>
                    Si por cualquier razón caducara este Mandato y Autorización, esta condición no me eximirá de la obligación de pagar las deudas pendientes que mantenga con la Isapre, conforme la normativa legal vigente.<br/><br/>
                    
                    6. El presente instrumento caducará en forma automática una vez extinguida la obligación de restitución de fondos por parte de Isapre Colmena.<br/><br/>
                  </p>
                <div class="callToActionModal">
                    <ul>
                        <li class="checkTerm">
                            <form [formGroup]="formDataFirma">
                                <p-checkbox 
                                    formControlName="checkFirma" 
                                    [binary]="true"
                                    inputId="binary"
                                     />
                               
                                    <p>
                                        Al hacer click en el siguiente botón, declaro mi conformidad y aceptación de los términos y obligaciones contenidos en este documento                                    </p>
                            </form>
                        </li>
                        <li>
                   
                                
                            <p-button styleClass="btn-submit" [disabled]="formDataFirma.controls['checkFirma'].value === false" label="Firmar" [loading]="loading" (onClick)="firmar()"/>

                            
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>

    </app-modal-compensacion>
</ng-container>
<ng-container *ngIf="viewNotificationFirma">
    <app-notificacion-firma-mandato [CodeResult]="codeResponseNotification" [TypeApp]="typeApp" [CurrentRutUser]="currentRutUser" [FolioMandato]="folioMandato" [NombreAfiliado]="nombreAfiliado"></app-notificacion-firma-mandato>
</ng-container>